// extracted by mini-css-extract-plugin
export default {"avatarWrap":"ProfileAvatar_avatarWrap__23MIS","overlay":"ProfileAvatar_overlay__XS4mq","avatarImg":"ProfileAvatar_avatarImg__f8VYV","uploading":"ProfileAvatar_uploading__u68RW"};